import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import applePodcasts from "../../../../assets/images/apple_podcasts.svg";
import googlePodcasts from "../../../../assets/images/google_podcasts.svg";
import spotifyIcon from "../../../../assets/images/spotify_podcasts.svg";
import overcastIcon from "../../../../assets/images/overcast_podcasts.svg";
import rssIcon from "../../../../assets/images/rss_podcasts.svg";
import castboxIcon from "../../../../assets/images/castbox.svg";
import stitcher from "../../../../assets/images/stitcher.png";
import { CloseIcon } from "../../atoms/close-icon";
import IntegrationData from "../../../../../config/integrations.js"

import "./podcast-podcatcher-subscribe-list.m.css";
import { useSelector } from "react-redux";
import { get } from "lodash";

export function PodcastPodcatcherSubscribeList({ showId }) {
  const integrationsConfig = IntegrationData();
  const podcatcherURLMap = integrationsConfig.podcatcherURLMap;
  
  return  (
    <div styleName="podcatchers-wrapper">
      {podcatchers.map(item => (
        <div key={item.key} styleName="podcatcher-item-wrapper">
          <div styleName="podcatcher-item">
            <a href={podcatcherURLMap[showId]&&podcatcherURLMap[showId][item.key]} target="__blank"> 
              <img src={item.asset} alt={item.alt}></img>
            </a>
          </div>
        </div>
      ))}
    </div>
  ) 
}

PodcastPodcatcherSubscribeList.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  showId: PropTypes.string
};


const podcatchers = [
  {
    name: "Apple podcasts",
    alt: "Listen on Apple podcasts",
    asset: assetify(applePodcasts),
    key: "Apple"
  },
  {
    name: "Google podcasts",
    alt: "Listen on Google podcasts",
    asset: assetify(googlePodcasts),
    key: "Google Podcasts"
  },
  { name: "Spotify", alt: "Listen on Spotify", asset: assetify(spotifyIcon), key: "Spotify" },
  {
    name: "Overcast",
    alt: "Listen on overcast",
    asset: assetify(overcastIcon),
    key: "Overcast"
  },
  
  {
    name: "RSS",
    alt: "Listen via RSS Feed",
    asset: assetify(rssIcon),
    key: "rss"
  }
];
